import { useRouter } from 'next/router';
import { getTranslation } from '../hoc/withDictionary';

export default function useDictionary() {
	return value => getTranslation(useRouter(), value);
}
